import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import type { OverlayDelay } from 'react-bootstrap/esm/OverlayTrigger';
import type { Placement } from 'react-bootstrap/esm/types';
import type { UsePopperOptions } from '@restart/ui/usePopper';

interface SidebarNavItemTooltipProps {
  id: string;
  title: string;
  placement?: Placement;
  delay?: OverlayDelay;
  disabled?: boolean;
  children: React.ReactElement;
  config?: Omit<UsePopperOptions, 'placement'>;
}

const TooltipWithArrow = ({ id, title, placement = 'top', delay = { show: 50, hide: 0 }, disabled = false, children, config = {} }: SidebarNavItemTooltipProps): JSX.Element => {
  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <OverlayTrigger
        placement={placement}
        delay={delay}
        popperConfig={config}
        // show={true}
        overlay={
          disabled ? (
            <></>
          ) : (
            <Tooltip id={id}>
              {title}
              <div data-popper-arrow></div>
            </Tooltip>
          )
        }>
        {children}
      </OverlayTrigger>
    </>
  );
};

export default TooltipWithArrow;
